import { render, staticRenderFns } from "./PessoaLink.vue?vue&type=template&id=17902534"
import script from "./PessoaLink.vue?vue&type=script&lang=js"
export * from "./PessoaLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports